export interface RAPIDRole {
  id: string;
  name: string;
  description: string;
  color: string;
  responsibilities: string[];
}

export interface RASCIRole {
  id: string;
  name: string;
  description: string;
  color: string;
  responsibilities: string[];
}

export interface ProjectInfo {
  date: string;
  projectSummary: string;
}

export interface Task {
  id: string;
  workArea: string;
  taskDescription: string;
  assignments: { [key: string]: string };
}

export interface Person {
  id: string;
  name: string;
  category: 'Leadership Team' | 'Project Team' | 'External Resources';
  isVisible?: boolean; // Optional for backwards compatibility
}

export const RAPID_ROLES: RAPIDRole[] = [
  {
    id: 'R',
    name: 'Recommend',
    description: 'Owns and drives decision process',
    color: '#d32f2f',
    responsibilities: [
      'Owns and drives decision process',
      'Obtains and synthesizes input',
      'Does 80% of the work'
    ]
  },
  {
    id: 'A',
    name: 'Agree',
    description: 'Ensures recommendation is feasible',
    color: '#1976d2',
    responsibilities: [
      'Ensures recommendation is feasible',
      'An "I" with teeth (not a second "D")',
      'Must be consulted',
      'Works with R to resolve any issues – unresolved issues decided by "D"'
    ]
  },
  {
    id: 'P',
    name: 'Perform',
    description: 'Understands intent and context of decision',
    color: '#f57c00',
    responsibilities: [
      'Understands intent and context of decision',
      'Drives timely execution as expected',
      'Performs decision action once decision is made'
    ]
  },
  {
    id: 'I',
    name: 'Input',
    description: 'Acts proactively and in a timely manner',
    color: '#757575',
    responsibilities: [
      'Acts proactively and in a timely manner to provide high quality input',
      'Must be consulted',
      'Input may or may not be reflected in final view'
    ]
  },
  {
    id: 'D',
    name: 'Decide',
    description: 'Makes the decision',
    color: '#388e3c',
    responsibilities: [
      'Works with the "R" to set clear expectations on process and timing',
      'Makes the decision'
    ]
  }
];

export const RASCI_ROLES: RASCIRole[] = [
  {
    id: 'R',
    name: 'Responsible',
    description: 'Does the work to complete the task',
    color: '#d32f2f',
    responsibilities: [
      'Does the work to achieve the task',
      'Directly responsible for task completion',
      'Can be multiple people per task',
      'Reports to the Accountable person'
    ]
  },
  {
    id: 'A',
    name: 'Accountable',
    description: 'Ultimately answerable for completion',
    color: '#388e3c',
    responsibilities: [
      'Ultimately answerable for the correct completion',
      'Only ONE person per task',
      'Signs off on work that Responsible provides',
      'Has yes/no/veto power'
    ]
  },
  {
    id: 'S',
    name: 'Support',
    description: 'Provides resources or assistance',
    color: '#f57c00',
    responsibilities: [
      'Provides resources to complete the task',
      'Assists with task completion',
      'Subject matter expertise when needed',
      'Not directly responsible for completion'
    ]
  },
  {
    id: 'C',
    name: 'Consulted',
    description: 'Two-way communication, provides input',
    color: '#1976d2',
    responsibilities: [
      'Provides input based on expertise',
      'Two-way communication required',
      'Must be consulted before decision',
      'Opinions are sought and considered'
    ]
  },
  {
    id: 'I',
    name: 'Informed',
    description: 'Kept updated on progress',
    color: '#757575',
    responsibilities: [
      'Kept up-to-date on progress',
      'One-way communication',
      'Informed after decisions are made',
      'No direct contribution to the task'
    ]
  }
];

export const PEOPLE: Person[] = [
  { id: 'P1', name: 'P1', category: 'Leadership Team', isVisible: true },
  { id: 'P2', name: 'P2', category: 'Leadership Team', isVisible: true },
  { id: 'P3', name: 'P3', category: 'Leadership Team', isVisible: true },
  { id: 'P4', name: 'P4', category: 'Leadership Team', isVisible: true },
  { id: 'P5', name: 'P5', category: 'Leadership Team', isVisible: true },
  { id: 'P6', name: 'P6', category: 'Leadership Team', isVisible: true },
  { id: 'P7', name: 'P7', category: 'Project Team', isVisible: true },
  { id: 'P8', name: 'P8', category: 'Project Team', isVisible: true },
  { id: 'P9', name: 'P9', category: 'Project Team', isVisible: true },
  { id: 'P10', name: 'P10', category: 'External Resources', isVisible: true },
  { id: 'P11', name: 'P11', category: 'External Resources', isVisible: true },
  { id: 'P12', name: 'P12', category: 'External Resources', isVisible: true }
]; 